

<ng-container
  *ngComponentOutlet="component(); inputs: inputs();">
</ng-container>
